import React, { Suspense } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';

// Routes
import {
    ARTIFACTS_MANAGEMENT_PATH,
    CAMPAIGN_PATH,
    DELIVERABLES_MANAGEMENT_PATH,
    DEVICES_PATH,
    GROUPS_PATH,
    OVERVIEW_PATH,
    REPORTS_BILLING_PATH,
    VEHICLES_PATH,
    WALKTHROUGH_PATH,
} from '~/features/base/constants/routes';

import ApplicationContentWrapper from '~/features/base/components/ApplicationContentWrapper';
import SubModuleContainer from '~/features/base/components/SubModuleContainer';

// Lazy load route components
const OverviewRoutes = React.lazy(() => import('~/features/overview/components/OverviewRoute'));
const DevicesRoute = React.lazy(() => import('~/features/devices/components/DevicesRoute'));
const GroupsRoute = React.lazy(() => import('~/features/groups/components/GroupsRoute'));
const ArtifactsRoute = React.lazy(() => import('~/features/artifacts/components/ArtifactsRoute'));
const DeliverablesRouteNeo = React.lazy(() => import('~/features/deliverables/components/DeliverablesRoute'));
const WalkthroughContainer = React.lazy(() => import('~/features/walkthrough/WalkthroughContainer'));
const ReportsBillingRoute = React.lazy(() => import('~/features/reportsbilling/components/ReportsBillingRoute'));
const VehiclesRoute = React.lazy(() => import('~/features/vehicles/components/VehiclesRoute'));
const CampaignRoute = React.lazy(() => import('~/features/campaigns/components/CampaignRoute'));

import { sendGoogleAnalyticsPageView } from '~/index';

const RouteLoadingFallback = () => <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;

// Wrapper component for lazy-loaded routes
const LazyRoute = ({ component: Component, ...props }) => (
    <Suspense fallback={<RouteLoadingFallback />}>
        <Route {...props} component={Component} />
    </Suspense>
);

export const getRoutes = ({ match }) => {
    // send Google Analytics Path
    sendGoogleAnalyticsPageView(match.path);
    return (
        <ApplicationContentWrapper>
            <SubModuleContainer>
                <Switch>
                    <LazyRoute path={`${match.path}${OVERVIEW_PATH}`} component={OverviewRoutes}/>
                    <LazyRoute path={`${match.path}${DEVICES_PATH}`} component={DevicesRoute}/>
                    <LazyRoute path={`${match.path}${VEHICLES_PATH}`} component={VehiclesRoute}/>
                    <LazyRoute path={`${match.path}${GROUPS_PATH}`} component={GroupsRoute}/>
                    <LazyRoute path={`${match.path}${ARTIFACTS_MANAGEMENT_PATH}`} component={ArtifactsRoute}/>
                    <LazyRoute path={`${match.path}${DELIVERABLES_MANAGEMENT_PATH}`} component={DeliverablesRouteNeo}/>
                    <LazyRoute path={`${match.path}${WALKTHROUGH_PATH}`} component={WalkthroughContainer}/>
                    <LazyRoute path={`${match.path}${REPORTS_BILLING_PATH}`} component={ReportsBillingRoute}/>
                    <LazyRoute path={`${match.path}${CAMPAIGN_PATH}`} component={CampaignRoute}/>
                    <Redirect to={`${match.url}${OVERVIEW_PATH}`}/>
                </Switch>
            </SubModuleContainer>
        </ApplicationContentWrapper>
    );
};

export const routes = withRouter(getRoutes);

export default routes;
